module.exports = __webpack_public_path__ + "media/images/fallback/figures/default_article_image_1-e6b4d5e74077783bc417cc854191367b.png";